<div class="section-header">
    <div class="title">
        Weitere Produkte
    </div>
    <div class="tab-title">
        Bitte fügen Sie die gewünschten Artikeln hinzu
    </div>
</div>

<div class="body">
    <div class="divider d1"></div>

    <app-no-order-items-info *ngIf="!model.isAccessoryOrderRequested"
                             [connectedTableId]="MyContainersTableIdEnum.step4AccessoriesTableContainers">
    </app-no-order-items-info>

    <app-projects-additional-items-table title="Zubehör"
                                         [forceFormValidationVisibility]="forceFormValidationVisibility"
                                         [tableItems]="model?.requestedAccessoryContainers"
                                         *ngIf="model.isAccessoryOrderRequested"
                                         [tableId]="MyContainersTableIdEnum.step4AccessoriesTableContainers">
    </app-projects-additional-items-table>

    <div class="divider d2"></div>



    <app-no-order-items-info *ngIf="!model.isWarrantyOrderRequested"
                             [connectedTableId]="MyContainersTableIdEnum.step4WarrantiesTableContainers">
    </app-no-order-items-info>
    <app-projects-additional-items-table title="Full Service Pack"
                                         [forceFormValidationVisibility]="forceFormValidationVisibility"
                                         [tableItems]="model?.requestedWarrantyContainers"
                                         *ngIf="model.isWarrantyOrderRequested"
                                         [tableId]="MyContainersTableIdEnum.step4WarrantiesTableContainers">
    </app-projects-additional-items-table>

    <div class="divider d3"></div>

    <ng-container *ngIf="model.isDeviceOrderRequested && model.containsSomeRequestedDevicesContainers()">

        <app-no-order-items-info *ngIf="!model.isServiceOrderRequested"
                                 [connectedTableId]="MyContainersTableIdEnum.step4ServicesContainers"
                                 class="mt-24">
        </app-no-order-items-info>
        <app-project-services-table [forceFormValidationVisibility]="forceFormValidationVisibility"
                                    class="mt-24 mb-24"
                                    *ngIf="model.isServiceOrderRequested">

        </app-project-services-table>

        <div class="divider d4"></div>
    </ng-container>



    <app-no-order-items-info *ngIf="!model.isUpgradesOrderRequested"
                             [connectedTableId]="MyContainersTableIdEnum.step4UpgradesContainers"
                             class="mt-24 mb-24">
    </app-no-order-items-info>
    <app-projects-additional-items-table title="Upgrades"
                                         [forceFormValidationVisibility]="forceFormValidationVisibility"
                                         [tableItems]="model?.requestedUpgradesContainers"
                                         class="mt-24 mb-24"
                                         *ngIf="model.isUpgradesOrderRequested"
                                         [tableId]="MyContainersTableIdEnum.step4UpgradesContainers">
    </app-projects-additional-items-table>



    <ng-container *ngIf="this.editModalService.dialogModelContainsSome4StepContainers() || (this.model.isServiceOrderRequested && this.model.isServiceDescriptionActive)">
        <div class="divider mt-24 d5"></div>

        <app-additional-items-extension-editor [forceFormValidationVisibility]="forceFormValidationVisibility"
                                               class="mt-24 mb-24">
        </app-additional-items-extension-editor>
    </ng-container>

</div>
